import { jsx as _jsx } from "react/jsx-runtime";
import { Avatars } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/MultiUser/Avatars";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import compact from "lodash/compact";
import React from "react";
export var AvatarRenderer = function(param) {
    var layoutElement = param.layoutElement;
    var simpleImageTitles = compact(layoutElement.layout_element_data.map(function(data) {
        return data.simple_image_title;
    }));
    var additionalUsers = simpleImageTitles.find(function(simpleImageTitle) {
        return !(simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.image) && !(simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.images.length);
    });
    var teamMemberUserData = simpleImageTitles.find(function(simpleImageTitle) {
        return (simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.image) || (simpleImageTitle === null || simpleImageTitle === void 0 ? void 0 : simpleImageTitle.images.length);
    });
    if (layoutElement.type === ILayoutElement.Type.TALL_CATEGORY_TILE && layoutElement.homepage_template_type === "EXPLORE" && teamMemberUserData) {
        return /*#__PURE__*/ _jsx(Avatars, {
            simpleImageTitle: teamMemberUserData,
            additionalUsers: additionalUsers === null || additionalUsers === void 0 ? void 0 : additionalUsers.main_text
        });
    } else {
        return null;
    }
};
